import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import Copyright from "../Copyright";
import SocialSection from "../SocialSection";
import { contactInfo } from "../../data/contactInfo";
import styles from "./Footer.module.css";

const platformLinks = [
  {
    label: "CureAR",
    to: "https://app.curear.com/",
    description: "Practice Management Software & Clearing House",
  },
  {
    label: "Credentialli",
    to: "https://app.credentialli.com/",
    description: "Credentialing Software",
  },
];
const offerLinks = [
  { label: "Medical Billing", to: "/services/medical-billing" },
  { label: "Denial Management", to: "/services/denial-management" },
  {
    label: "Credentialing & Enrollment",
    to: "/services/credentialing-and-enrollment",
  },
  { label: "Account Receivables", to: "/services/account-receivables" },
  { label: "Prior Authorization", to: "/services/prior-authorization" },
  {
    label: "Verification of Benefits",
    to: "/services/verification-of-benefits",
  },
  { label: "Virtual Medical Scribe", to: "/services/virtual-medical-scribe" },
  { label: "Virtual Assistant", to: "/services/virtual-assistant" },
];

const contactItems = [
  {
    icon: <FaPhoneAlt />,
    label: contactInfo.phoneDisplay,
    href: contactInfo.phoneHref,
  },
  {
    icon: <FaEnvelope />,
    label: contactInfo.email,
    href: contactInfo.emailHref,
  },
  {
    icon: <FaMapMarkerAlt />,
    label: contactInfo.address,
    href: contactInfo.addressMapHref,
  },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.topRow}`}>
        <div className={styles.brandColumn}>
          <img
            src="/logo/main-logo-w.webp"
            alt="Physicians Success Partners"
            className={styles.logo}
          />
          <p>
            Physicians Success Partners is a full-service medical billing
            consulting company managing coding, claims, payments, and
            follow-ups, so you can focus on patient care.
          </p>
          <SocialSection />
        </div>

        <div className={styles.navColumn}>
          <h3> What We offer</h3>
          <nav className={styles.linkList} aria-label="About footer links">
            {offerLinks.map((item) => (
              <Link key={item.label} to={item.to}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className={styles.navColumn}>
          <h3>Our Platforms</h3>
          <div className={styles.linkList}>
            {platformLinks.map((item) => (
              <div className={styles.platformItem} key={item.label}>
                <h4>
                  <a href={item.to} target="_blank" rel="noreferrer">
                    {item.label}
                  </a>
                </h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.navColumn}>
          <h3>Meet Us</h3>
          <div className={styles.contactList}>
            {contactItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={styles.contactItem}
                target={item.href.startsWith("https://") ? "_blank" : undefined}
                rel={
                  item.href.startsWith("https://") ? "noreferrer" : undefined
                }
              >
                <span>{item.icon}</span>
                <p className={styles.contactText}>{item.label}</p>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="container">
        <div className={styles.divider} />
        <Copyright />
      </div>
    </footer>
  );
}
